/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Cancel_Application_ErrorInputs */

const en_candidate_cancel_application_error = /** @type {(inputs: Candidate_Cancel_Application_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The application could not be canceled.`)
};

const de_candidate_cancel_application_error = /** @type {(inputs: Candidate_Cancel_Application_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Bewerbung konnte nicht storniert werden.`)
};

/**
* | output |
* | --- |
* | "The application could not be canceled." |
*
* @param {Candidate_Cancel_Application_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_cancel_application_error = /** @type {((inputs?: Candidate_Cancel_Application_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Cancel_Application_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_cancel_application_error(inputs)
	return en_candidate_cancel_application_error(inputs)
});